import Vue from 'vue'
import 'chartist/dist/chartist.min.css'
import VueApexCharts from 'vue-apexcharts'

Vue.use(require('vue-chartist'))
Vue.use(VueApexCharts)

Vue.component('Apexchart', VueApexCharts)
